import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const PaymentPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const checkAdmin = async () => {
      const user = auth.currentUser;
      if (user && user.email === 'admin@arrow.com') {
        navigate('/dashboard');
      }
    };

    checkAdmin();
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    setLoading(true);
    setError('');

    const res = await loadRazorpayScript();
    if (!res) {
      setError('Failed to load Razorpay SDK.');
      setLoading(false);
      return;
    }

    try {
      const { data } = await axios.post(`${API_BASE}/api/payment/create-order`, {
        amount: 499
      });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.order.amount,
        currency: data.order.currency,
        name: 'Arrow Bulk Email Sender',
        description: 'Payment for Arrow',
        order_id: data.order.id,
        handler: async function (response) {
          try {
            const token = await auth.currentUser.getIdToken();
            await axios.post(
              `${API_BASE}/api/payment/verify`,
              {
                payment_id: response.razorpay_payment_id,
                order_id: response.razorpay_order_id,
                signature: response.razorpay_signature
              },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            alert('Payment Verified & Access Granted!');
            window.location.href = '/dashboard';
          } catch (err) {
            console.error(err);
            setError('Payment verification failed. Please contact support.');
          }
        },
        modal: {
          ondismiss: () => {
            setError('Payment cancelled.');
          }
        },
        theme: { color: '#3399cc' }
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function (response) {
        setError(`Payment failed: ${response.error.description}`);
      });
      rzp.open();
    } catch (err) {
      console.error(err);
      setError('Failed to create payment order. Try again later.');
    }

    setLoading(false);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('userId');
      window.location.href = '/login';
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Arrow Payment Gateway</h1>
        <button
          onClick={handleLogout}
          className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
        >
          Logout
        </button>
      </div>

      <div className="space-y-4 max-w-md">
        <p className="text-gray-700">
          To unlock full access, please complete a ₹499 payment.
        </p>
        {error && <div className="text-red-600">{error}</div>}
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded w-full"
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Pay ₹499 with Razorpay'}
        </button>
      </div>
    </div>
  );
};

export default PaymentPage;
